import type { HelpGap } from './model';
import type { HelpLayer } from './layerTypes';

/**
 * One gap as the panel shows it (ADR-0066): from the server layer when it loaded (the truth for
 * status and answers), else from the compiled file's front matter (`fromServer: false`; the SME
 * actions are disabled because there is nothing to post to).
 */
export interface GapView {
  gapId: string;
  section: string;
  question: string;
  status: string;
  answerMd: string | null;
  answeredBy: string | null;
  rejectNote: string | null;
  issueId: number | null;
  fromServer: boolean;
}

export function mergeGaps(layer: HelpLayer | undefined, fileGaps: HelpGap[] | undefined): GapView[] {
  if (layer) {
    return layer.gaps.map((g) => ({
      gapId: g.gapId,
      section: g.section,
      question: g.question,
      status: g.status,
      answerMd: g.answerMd,
      answeredBy: g.answeredBy,
      rejectNote: g.rejectNote,
      issueId: g.issueId,
      fromServer: true,
    }));
  }
  return (fileGaps ?? []).map((g) => ({
    gapId: g.id,
    section: g.section,
    question: g.question,
    status: g.status,
    answerMd: null,
    answeredBy: null,
    rejectNote: null,
    issueId: null,
    fromServer: false,
  }));
}

/** The backend treats anything but `resolved` as open (a reject goes back to `open`). */
export function isOpenGap(g: GapView): boolean {
  return g.status !== 'resolved';
}
